// Shared constants for the IM "Recalculate Kit Usage Details" screen (legacy IMD0086).
//
// Declared once so the page and its Preview grid cannot drift, and so nothing in either file is a bare
// literal (Architecture.md -> Reviewer-Judgment Concerns R2).

// Report definition name. Must match Argos.Core/Report/IM/RecalculateKitUsage.Name and the
// ReportFactory case label, which is compared after reportName.ToUpper().
export const REPORT_NAME = "RecalculateKitUsage";

// Assembly-qualified name, matching RecalculateKitUsage.FullName. <CommonReport> sends this to
// rt/Report/GetReport alongside the name.
export const REPORT_FULL_NAME = "Argos.Report.IM.RecalculateKitUsage, Argos.Report.IM";

// lblTitle on the Delphi form (uIMD0086.dfm). The form's own Caption is the generic
// 'Standard Abecas Program Form' placeholder, so this label is the screen's real name.
export const PAGE_TITLE = "Recalculate Kit Usage Details";

// Toolbar captions, verbatim from the Delphi buttons (uIMD0086.dfm grpBottomButtons). Help and Exit are
// not migrated: Help had no OnClick wired at all and Exit closed the MDI child.
export const BUTTON = Object.freeze({
    Start: "Start",
    Preview: "Preview",
    Reset: "Reset",
});

export const PREVIEW_TITLE = "Preview";

// Saved-layout identity for the Preview grid. A GUID of its own so this grid's saved layout cannot
// collide with another screen's.
export const PREVIEW_GRID_KEY = "3B7C9E42-15AD-4C86-9F30-6D2A81E4B5C7";

/**
 * IMITEMKITTHEADER.STATUS. Codes and labels verbatim from uIMM0086.dfm, in DFM order, and identical to
 * the FlagType pairs in Argos.Core/Report/IM/RecalculateKitUsage.StatusFlags().
 *
 * Rendered as a dropdown in both places the code is user-visible (Architecture.md rule 3): the criteria
 * grid gets a SelectBox from the report's own Flag metadata, and the Preview grid uses these through a
 * <Lookup>.
 */
export const KIT_STATUS_OPTIONS = [
    { ID: "A", Text: "Active" },
    { ID: "I", Text: "Inactive" },
];

/**
 * IMITEMKITTHEADER.PMUSE. Codes and labels verbatim from uIMM0086.dfm, in DFM order, and identical to
 * RecalculateKitUsage.PmUseFlags().
 */
export const KIT_PM_USE_OPTIONS = [
    { ID: "A", Text: "Not Used" },
    { ID: "B", Text: "Produces Only Same Item" },
    { ID: "C", Text: "Produces Multiple Items" },
];

// The WhereInfo enum lookups (FieldType / Operation / OrderBy / Prefix / Group) that used to live here
// are gone: <CommonReport> and its ReportFilter own the criteria grid's editors and the Flag
// code-to-description translation, so this screen no longer mirrors those enums client-side. Keeping a
// second copy of them here would be a copy that could drift from the server's without anything failing.

// The legacy screen blocked its UI behind a "Recalculating Kit Usage Quantities - Please Wait" modal, so
// a long run is expected. Kept above the service's own 900s command timeout
// (KitUsageRecalculationConstants.CommandTimeoutSeconds) so the server, not the browser, decides when a
// run has taken too long.
export const REQUEST_TIMEOUT_MS = 20 * 60 * 1000;
